import { Container, Row, Col, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import RoteiroColeta from "./TabelaColeta";

export default function TabelaBairros() {
  return (
    <section id="rota-coleta" className="py-5 bg-light">
      <Container>
        <Row className="text-center mb-5">
          <Col>
            <h2 className="display-5 fw-bold text-dark mb-3">
              Roteiro da Coleta Seletiva
            </h2>
            <p className="lead text-muted">
              Confira os dias e bairros atendidos pela coleta seletiva em
              Guaratinguetá.
            </p>
            <RoteiroColeta />
          </Col>
        </Row>

        <Row>
          <Col>
            <Table striped bordered hover responsive className="shadow-sm">
              <thead className="table-success">
                <tr>
                  <th>Dia da Semana</th>
                  <th>Bairros Atendidos</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fw-bold">Segunda a Sexta</td>
                  <td>Centro</td>
                </tr>
                
                <tr>
                  <td className="fw-bold">Segunda e Quarta</td>
                  <td>
                    Bosque dos Ipês, Jardim Modelo, Parque Santa Clara, Pedreira,
                    Pingo de Ouro, Pq São Francisco 1 e 2, Res. Coopemi, Res.
                    David Fernandes Coelho, Res. Vale das Serras, Res. Vista das
                    Paineiras, Residencial Mantiqueira, Retiro / São Benedito,
                    Santa Bárbara, São Dimas, São Sebastião, Vila dos
                    Comerciários 1 e 2, Village Santana, Villagio Italian.
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Quarta e Sexta</td>
                  <td>
                    Campinho, Chácaras Selles, Figueira, Jardim França 1 e 2,
                    Jardim Nova Era, Res. Augusto Filippo, Residencia Itália,
                    Residencial Espanha, Santa Luzia, Santa Rita, São Benedito,
                    São Bento, Vila Alves, Vila Guará, Vila Municipal 1 e 2,
                    Vila Pajé.
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Segunda e Sexta</td>
                  <td>
                    Bela Vista, Bom Jardim, Cecap, Coelho Neto, Colônia Piagui,
                    Esplanada/Vila Indiana, Jardim Aeroporto, Jardim das
                    Figueiras, Jardim Esplanada, Jardim Independência, Jardim
                    Rony, Loteamento Nino, Parque das Árvores, Parque das
                    Garças, Pedregulho, Primori, Quaresmeiras, Res.Eurico Dutra,
                    Resedas, Residencial COOPERI, Residencial Costa e Silva,
                    Santa Edwiges, São Manoel, Vila Comendador, Vila dos
                    Funcionários, Vila Galvão, Vila Molica, Walter
                    Arantes/Matadouro.
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Terça e Quinta</td>
                  <td>
                    Beira Rio 1 e 2, Campo do Galvão, Chácara Agrícola Jardim do
                    Vale, Chácara Santa Maria, Chácara Vitória, Clube dos 500,
                    COHAB, Condominio Pref. Gilberto Filippo, Engenheiro Neiva,
                    Flamboyants 1, 2 e 3, Hípica, IAPI, Internacional Park,
                    Jardim do Vale 1 e 2, Jardim Esperança, Jardim Pérola,
                    Jardim Primavera, Jardim Tamandaré, Jardim Vista Alegre,
                    Mirante, Nova Guará, Nova República, Panorama 1 e 2, Parque
                    Alberto Bayington, Parque das Alamedas, Parque do Sol,
                    Portal das Colinas, Residencial Santa Mônica, Vila Angelina,
                    Vila Bela, Vila Brasil, Vila Ofélia, Vila Paraíba, Vila
                    Paulista, Vila Regina, Vila Rosa, Vila Santa Mônica, Vila
                    Sapé, Village Mantiqueira.
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Terça-feira somente</td>
                  <td>Pedrinhas</td>
                </tr>

                <tr>
                  <td className="fw-bold">Quarta-feira somente</td>
                  <td>Rocinha</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </section>
  );
}